import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-tables',
  imports: [DesyAngularModule, CommonModule],
  templateUrl: './tables.component.html',
  styleUrl: './tables.component.scss',
  standalone: true,
})
export class TablesComponent {
  @Input() itemsTableHeader;
  @Input() itemsTableRows;
}
